import { useTranslation } from 'react-i18next';

import { FormDatePicker } from '@components/form-date-picker/form-date-picker';
import { Field } from 'formik';
import { getCurrentUserService } from 'src/current-user/infrastructure/getters';
import { SystemRole } from 'src/user/domain/system-role.entity';

export default function CreateNewStandardEATimeline() {
	const { t } = useTranslation();
	const currentUserService = getCurrentUserService();

	const disabled = !currentUserService.hasRole([SystemRole.DIRECTOR, SystemRole.ES]);

	return (
		<>
			<Field
				component={FormDatePicker}
				name="enData.publicationDate"
				label={t('standard.singleStandardPage.enData.dateEa')}
				placeholder="Choose date"
				mandatory={false}
				showError
				useSubmitOnBlur
				fullWidth
				isClearable
				disabled={disabled}
			/>
		</>
	);
}
